import { registerPlugin } from '@capacitor/core';

const JsPlugin = registerPlugin('MyPlugin');

export default JsPlugin;
